export default "<div class=\"spinner\">\n    <div class=\"cube1\"></div>\n    <div class=\"cube2\"></div>\n  </div>"